export enum TableCellTypeEnum {
    TEXT,
    IMAGE,
    BUTTON,
    CHECKBOX,
    DROPDOWN,
    HYPERLINK,
    DATE
}